import React from "react";
import PropTypes from "prop-types";
import TranslationRepositoryContext from "../contexts/TranslationRepositoryContext";
import EnvRepositoryAdapter from "./EnvRepositoryAdapter";
import TranslationHelper from "../helpers/TranslationHelper";
import Translator from "../core/Translator";
import useOnLocaleChange from "../hooks/use-on-locale-change";
import {useEventListeners} from "@morningtrain/react-helpers";
import useLocale from "../hooks/use-locale";
import useSetLocale from "../hooks/use-set-locale";

function TranslationRepository(props) {

    const adapter = props.adapter;

    const locale = useLocale();
    const [loaded, setLoaded] = React.useState(false);

    const [triggerHasLoaded, onLoaded, removeOnLoaded] = useEventListeners();

    const repository = new TranslationHelper(adapter);

    /// TODO - Build these directly into repository/adapter or make a better decoupling
    repository.onLoaded = onLoaded;
    repository.removeOnLoaded = removeOnLoaded;

    React.useEffect(() => {
        adapter
            .load(locale.get())
            .then(() => {
                setLoaded(true);
            });
    }, []);

    useOnLocaleChange(locale => {
        adapter.load(locale).then(() => {
            /// This should ideally be triggered on initial load also
            /// - but it might not be an issue, as we do not render before it is loaded anyways
            triggerHasLoaded(locale);
        });
    });

    if (loaded === false) {
        return null;
    }

    return (
        <TranslationRepositoryContext.Provider value={repository}>
            <Translator>
                {props.children}
            </Translator>
        </TranslationRepositoryContext.Provider>
    );
}

TranslationRepository.defaultProps = {
    adapter: new EnvRepositoryAdapter(),
};

TranslationRepository.propTypes = {
    adapter: PropTypes.object,
};

export default TranslationRepository;
